/** Pagination catalogue modèles 3D garage (10 par lot). */
export const PAGE_SIZE = 10;

export type ModelsPageMeta<T> = {
  items: T[];
  hasMore: boolean;
};

/** Page 1-based minimale qui contient l’index 0-based (pour scroll vers un slug). */
export function pageForIndex(index: number, pageSize: number = PAGE_SIZE): number {
  if (index < 0) return 1;
  const size = Math.max(1, Math.floor(pageSize));
  return Math.floor(index / size) + 1;
}

export function sliceModelsPage<T>(items: T[], page: number): T[];
export function sliceModelsPage<T>(
  items: T[],
  page: number,
  opts: { withMeta: true }
): ModelsPageMeta<T>;
export function sliceModelsPage<T>(
  items: T[],
  page: number,
  opts?: { withMeta?: boolean }
): T[] | ModelsPageMeta<T> {
  const safePage = Math.max(1, Math.floor(page));
  const end = safePage * PAGE_SIZE;
  const sliced = items.slice(0, end);
  if (opts?.withMeta) {
    return { items: sliced, hasMore: end < items.length };
  }
  return sliced;
}
